import { EVENT_STATUS } from "../../Trader/Cricket/decimalEventStatus";
import { EVENT_STATUS_DISPLAY } from "./bullionPlayedUiConstants";

export const MATCH_DETAILS_TABS = ["SCORECARD", "COMMENTARY", "LINEUP", "CHARTS"] as const;
export type MatchDetailsTab = (typeof MATCH_DETAILS_TABS)[number];

const EVENT_STATUS_STRINGS: Record<string, number> = {
    MATCH_SCHEDULED: EVENT_STATUS.MATCH_SCHEDULED,
    MATCH_STABLE: EVENT_STATUS.MATCH_STABLE,
    BALL_IN_PROGRESS: EVENT_STATUS.BALL_IN_PROGRESS,
    UNKNOWN_EVENT: EVENT_STATUS.UNKNOWN_EVENT,
    RUNS_LIKELY: EVENT_STATUS.RUNS_LIKELY,
    POSSIBLE_WICKET: EVENT_STATUS.POSSIBLE_WICKET,
    UMPIRE_REVIEW: EVENT_STATUS.UMPIRE_REVIEW,
    BREAK_IN_PLAY: EVENT_STATUS.BREAK_IN_PLAY,
    DATA_ASSEMBLY_ISSUE: EVENT_STATUS.DATA_ASSEMBLY_ISSUE,
    SUPER_OVER: EVENT_STATUS.SUPER_OVER,
    MATCH_COMPLETE: EVENT_STATUS.MATCH_COMPLETE,
    EVENT_CLOSED: EVENT_STATUS.EVENT_CLOSED,
    EJECTED: EVENT_STATUS.EJECTED,
};

export function getEventStatusDisplayLabel(eventStatus: unknown): string | null {
    if (eventStatus == null || eventStatus === "") return null;
    const num = typeof eventStatus === "number" ? eventStatus : parseInt(String(eventStatus), 10);
    if (Number.isFinite(num) && EVENT_STATUS_DISPLAY[num]) return EVENT_STATUS_DISPLAY[num]!.text;
    const u = String(eventStatus).toUpperCase().replace(/-/g, "_").trim();
    const id = EVENT_STATUS_STRINGS[u];
    if (id !== undefined && EVENT_STATUS_DISPLAY[id]) return EVENT_STATUS_DISPLAY[id]!.text;
    return null;
}

export function looksLikeLiveCricketScoreboard(scoreA: string, scoreB: string): boolean {
    const a = String(scoreA || "").trim();
    const b = String(scoreB || "").trim();
    if (!a || !b) return false;
    if (a === "--" || b === "--") return false;
    // Anything beyond "0/0" on either side strongly suggests play has started.
    if (a !== "0/0" || b !== "0/0") return true;
    return false;
}
